import { Color } from './types'

export const getColorById = (colors: Color[], id: string): string | undefined => {
  const color = colors?.find((color: Color) => color.id === id)
  return color?.color_value
}

export const mergeColorsWithDefaults = (
  currentColors: Color[],
  defaultColors: Color[],
): Color[] => {
  const colorMap = new Map<string, Color>()

  defaultColors.forEach((control) => {
    colorMap.set(control.id, control)
  })

  return currentColors.map((color) => ({
    ...color,
    section_label: color.section_label ?? colorMap.get(color.id)?.section_label,
  }))
}
